import { getCategoryIds } from "../../../utils/helpers/aiAgent/utils";
import classes from "./ChatMessages.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { formatDateByLanguage } from "../../../utils/time";

const ChatMessages = ({ chatMessages, setChatMessages, setOpen, allCategories, t, ctxLang }) => {
  const navigate = useNavigate();
  const chatBodyRef = useRef(null);

  useEffect(() => {
    if (!chatBodyRef.current) return;

    chatBodyRef.current.scrollTo({
      top: chatBodyRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [chatMessages]);

  function handleChoiceClick(msg, route) {
    const payload = msg?.payload;
    if (payload) {
      const { searchText, categories = [], ageGroup = [], type } = payload;
      const ids = getCategoryIds(allCategories, categories);

      const storageMap = {
        products: { key: "checkedData", searchKey: "productsSearchText", data: { categories: ids, ageGroup, type } },
        cartoons: { key: "cartoonCheckedData", searchKey: "cartoonsSearchText", data: { categories: ids, ageGroup } },
      };

      const config = storageMap[route];
      if (config) {
        sessionStorage.setItem(config.key, JSON.stringify(config.data));
        sessionStorage.setItem(config.searchKey, searchText);
      }
    }

    navigate(`/${route}`);
    setOpen("");
    setChatMessages([]);
  };

  return (
    <div ref={chatBodyRef} className={classes.chatBody}>
      {chatMessages.map((msg) => {
        const isUser = msg.sender === "user";
        const isError = msg.type === "error";
        const isChoice = msg.type === "choice";

        return (
          <div
            key={msg.id}
            className={`
              ${isUser ? classes.userMessage : classes.aiMessage}
              ${isError ? classes.errorMessage : ""}
            `}
          >
            {msg.loading && !isError ? (
              <span>{t(msg.text) || msg.text}<span className={classes.dots}></span></span>
            ) : isError ? (
              msg.resetsAt ? (
                t("ai_limit_reached_with_time").replace("{time}", formatDateByLanguage(msg.resetsAt, ctxLang, true))
              ): (
                `🚫 ${t(msg.text) || msg.text}`
              )
            ) : isChoice ? (
              <div className={classes.resultsContainer}>
                <span className={classes.resultsText}>{t("results_both_books_and_cartoons")}</span>
                <div className={classes.buttonsWrapper}>
                  <div className={classes.buttonBooks} onClick={() => handleChoiceClick(msg, "products")}>
                    <span>{t("go_to_books")}</span>
                  </div>
                  <div className={classes.buttonCartoons} onClick={() => handleChoiceClick(msg, "cartoons")}>
                    <span>{t("go_to_cartoons")}</span>
                  </div>
                </div>
              </div>
            ) : (
              msg.text
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ChatMessages;